<template>
<!--
  <comments 
  v-bind:comments="convo.meta.comments" 
  v-bind:model="convo"
  v-on:addComment="addConvoComment()"
  v-on:removeComment="removeConvoComment($event)"
  />
-->
  <div class="comments">
  <div v-for="(comment) in convo.meta.comments" :key="comment.id">
    <convo-comment v-bind:comment="comment" v-bind:convo="convo" />
  </div>
  <div v-if="!isAuthenticated" style="text-align:center">
    <login-button v-bind:text="'Login to comment'" />
  </div>
  <div v-else>
    <hr class="w3-clear">
    <div>
    <input type="text" name="commentTitle" placeholder="TITLE" v-model="convo.meta.newCommentTitle" class="form-control">
    </div>
    <div>
    <textarea-autosize rows="3" placeholder="COMMENT" v-model="convo.meta.newCommentBody" class="form-control"></textarea-autosize>
    </div>
    <div>
      <span>
        <save-button @save="addConvoComment()" v-bind:type="'fal'" v-bind:icon="'comment'"/>
      </span>
      <span>
        <button @click="addStatements()" type="button" class="w3-button w3-text-theme">
          <font-awesome-icon :icon="['fal', 'comment-alt-check']" />
          <font-awesome-icon :icon="['fal', 'plus']" style="position:relative; left:-4px;" />
           Add Statements
        </button> 
      </span>
    </div>
  </div>
  </div>
</template>

<script>
  import ConvoComments from "./ConvoComments.ts";

  export default ConvoComments;
</script>
